export class ClassUtils {
    static regClass(className, classDef) {
        ClassUtils._classMap[className] = classDef;
    }
    static getClass(className) {
        return ClassUtils._classMap[className];
    }
    static regRuntime(url, cls) {
        ClassUtils._runtimeMap[url] = cls;
    }
    static getRuntime(url) {
        return ClassUtils._runtimeMap[url];
    }
}
ClassUtils._classMap = {};
ClassUtils._runtimeMap = {};
